import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { ApiNameList } from 'src/environments/api-name-list';
import { AppConfigService } from '../../main/app-config.service';
import { AppConstants } from '../constants/app-constants';
import { UserCacheService } from './user-cache.service';
@Injectable()
export class WcsApiService {
    private environment: any;
    private wcsUrl: any;
    constructor(private http: HttpClient, public userCacheService: UserCacheService, private router: Router, private appConfigService: AppConfigService) {
        this.environment = this.appConfigService.getConfig();
        //this.wcsUrl = "https://internal-ems-dev-ui-lb-1740877624.us-east-1.elb.amazonaws.com/" + environment.baseUrlOWCS; //Rewrite the baseUrl.
        this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS; //Rewrite the baseUrl.
    }

    /**
     * Method to fetch WCS template based on page route.
     * @param pageRoute 
     */
    getWcsContent(pageRoute: string) {
        try{
            const participationId = this.getParticipation(this.router.url);
            const micrositeId = this.getMicrositeId(this.router.url);;
            if(participationId){
                this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS + pageRoute + '?planId=' + participationId;
            } else if(micrositeId){
                this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS + pageRoute + '?planId=' + micrositeId.toLowerCase();
            } else {
                this.wcsUrl = ApiNameList.restApi.baseUrl + this.environment.baseUrlWCS + pageRoute;
            }
            if (this.environment.environment === 'local') {
                this.wcsUrl = 'https://studentenroll.sit1-az.anthem.com/' + this.environment.baseUrlWCS + pageRoute + '?planId=' + participationId;
            }
            return this.http.get(this.wcsUrl, { responseType: 'text' });
        } catch (e) {
            return null;
        }
    }

    getParticipation(url: string) {
        let participationId = null;
        const urlObj = url.match(/^\/(\d+)\/?/);
        if (urlObj && urlObj.length > 0) {
            participationId = parseInt(urlObj[1], 10);
        }
        if(!participationId) {
            participationId = this.userCacheService.getUserData(AppConstants.PARTICIPATION_ID);
        }
        return participationId? participationId.toString() : '';
    }

    getMicrositeId(url: string) {
        let micrositeId = null;
        const urlObj = url.match(/^\/school\/([a-zA-Z]+)\/?/);
        if (urlObj && urlObj.length > 0) {
            micrositeId = urlObj[1];
        }
        if(!micrositeId) {
            micrositeId = this.userCacheService.getUserData(AppConstants.MICROSITE_ID);
        }
        return micrositeId;
    }
}